export interface StudioQuestion {
  id: string;
  prompt: string;
  options: { value: string; label: string; icon_svg?: string }[];
  group?: string;
  help?: string;
  required?: boolean;
  multiple?: boolean;
  depends_on?: { question_id: string; value: string } | null;
}
export type StudioAnswers = Record<string, string | string[]>;
export function visibleQuestions(questions: StudioQuestion[], answers: StudioAnswers) {
  return questions.filter(q => !q.depends_on || answers[q.depends_on.question_id] === q.depends_on.value);
}
export function hasAnswer(value: string | string[] | undefined) {
  return Array.isArray(value) ? value.length > 0 : !!value;
}
export function requiredComplete(questions: StudioQuestion[], answers: StudioAnswers) {
  return visibleQuestions(questions, answers).every(q => q.required === false || hasAnswer(answers[q.id]));
}
export function activeAnswers(questions: StudioQuestion[], answers: StudioAnswers): StudioAnswers {
  const ids = new Set(visibleQuestions(questions, answers).map(q => q.id));
  return Object.fromEntries(Object.entries(answers).filter(([key]) => ids.has(key)));
}
